import { Button, TextArea } from "react-aria-components"
import { modalSignal } from "./ModalContainer"
import infoIcon from "../../../assets/icons/icon-information.svg"
import destructiveIcon from "../../../assets/icons/icon-exclamation-red.svg"
import LoadingButton from "../LoadingButton"
import { useState } from "react"

interface ICancelPicklistModal {
    heading: string,
    information: string,
    ContinueFunc: Function,
    cancelFunc?: Function
    type?: ConfirmType,
    autoClose?: boolean | null | undefined
}

export enum ConfirmType {
    Info = 1,
    Destructive
}

const iconMap = {
    [ConfirmType.Info]: infoIcon,
    [ConfirmType.Destructive]: destructiveIcon
};

export default function CancelPicklistModal({ heading, information, ContinueFunc, type, cancelFunc, autoClose }: ICancelPicklistModal) {
    const [loading, setLoading] = useState<boolean>(false);
    const [notes, setNotes] = useState<string | undefined>();

    async function handleContinue() {
        setLoading(true);
        await ContinueFunc(notes);
        setLoading(false);
        if (autoClose == undefined || autoClose === null || autoClose === true) {
            modalSignal.value = undefined;
        }
    }

    function handleCancel() {
        modalSignal.value = undefined;
        if (cancelFunc) {
            cancelFunc();
        }
    }

    function resolveIcon(): string {
        return iconMap[type ?? ConfirmType.Info];
    }

    return (
        <div className="display--flex flex__direction--column alignItems--center gap--xs">
            <img src={resolveIcon()} />
            <h1>{heading}</h1>
            <p className="textAlign--center whitespace--pre-line">{information}</p>
            <div>
                <p className="margin__top--m margin__bottom--xxs">Cancellation notes:</p>
                <TextArea value={notes} onChange={(e) => setNotes(e.target.value)}
                    aria-label="Notes"
                    className={"pick-list__side-panel-text-area"}
                    cols={50}
                    rows={30} />
            </div>
            <div className="margin__top--xs display--flex gap--xs">
                <Button className=" button button--large button--secondary button--with-icon" onPress={handleCancel} isDisabled={loading}>
                    <p className="button-text">Cancel</p>
                </Button>
                <LoadingButton className="button button--large button--primary button--with-icon"
                    onPress={handleContinue}
                    buttonText="Confirm"
                    loadingText="Confirming"
                    isDisabled={loading}
                    isLoading={loading}>
                    <></>
                </LoadingButton>
            </div>
        </div>)
}


